import React from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import { AuthProvider } from "./context/AuthContext";
import Login from "./Login";
import Dashboard from "./pages/Dashboard";
import MainPage from "./pages/MainPage";
import QaPage from "./pages/QaPage";
import UserPage from "./pages/UserPage";
import DoctorPage from "./pages/DoctorPage";
import DiscountPage from "./pages/DiscountPage";
import DiscountOverviewPage from "./pages/DiscountOverviewPage";
import InvitePage from "./pages/InvitePage";
import AdvicePage from "./pages/AdvicePage";
import AdviceManagePage from "./pages/AdviceManagePage";
import UserManagePage from "./pages/UserManagePage";
import UserAgreement from "./pages/login/UserAgreement";
import PrivacyPolicy from "./pages/login/PrivacyPolicy";

// 主应用组件，包含路由
const App: React.FC = () => {
  return (
    <AuthProvider>
      <Router>
        <Routes>
          <Route
            path="/login"
            element={
              <Login onLoginSuccess={() => (window.location.href = "/")} />
            }
          />
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/qa" element={<QaPage />} />
          <Route path="/user" element={<UserPage />} />
          <Route path="/doctor" element={<DoctorPage />} />
          <Route path="/discount" element={<DiscountPage />} />
          <Route path="/discount-overview" element={<DiscountOverviewPage />} />
          <Route path="/invite" element={<InvitePage />} />
          <Route path="/advice" element={<AdvicePage />} />
          <Route path="/advice-manage" element={<AdviceManagePage />} />
          <Route path="/user-manage" element={<UserManagePage />} />
          <Route path="/user-agreement" element={<UserAgreement />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/" element={<MainPage />} />
        </Routes>
      </Router>
    </AuthProvider>
  );
};

export default App;
